<template>
<v-card>
  <v-card-title class="secondary white--text">
    <v-btn small dark icon>
      <v-icon>fa-blank</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <h5>My Current Rank</h5>
    <v-spacer></v-spacer>
    <v-btn small dark icon @click="$eventBus.$emit('play_video',$store.state.app.tutorials.progress['My Current Rank'])">
      <v-icon>fa-question</v-icon>
    </v-btn>
  </v-card-title>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="6" lg="4" class="text-center">
        <h3>Current Rank</h3>
        <v-btn large fab dark :class="`mt-2 rank-${account.rank}-bg`">
          <h1 class="font-weight-bold">{{account.rank}}</h1></v-btn>
        <h4 class="mt-2">Max pay: <span class="green--text text--darken-2">${{payscale[account.rank]}}</span></h4>
      </v-col>
      <v-col cols="6" lg="4" class="text-center">
        <h3><v-icon class="mb-1">fa-lock</v-icon> Next Rank</h3>
        <v-btn large fab dark color="yellow darken-3" :class="`mt-2 rank-${account.rank+1}-bg`">
          <h1 class="font-weight-bold">{{account.rank + 1}}</h1></v-btn>
        <br />
        <h4 class="mt-2">Max pay: <span >${{payscale[account.rank+1]}}</span></h4>
      </v-col>
    </v-row>
  </v-container>
</v-card>
</template>
<script>
export default {
  name: "",
  props: ['account'],
  data: () => ({
    payscale: {
      1: 30,
      2: 60,
      3: 120,
      4: 240,
      5: 480,
      6: 960,
      7: 1920,
      8: 3840,
      9: 7680,
      10: 15360
    },
  })
}
</script>
<style lang="scss" scoped>
</style>
